import { faPlus } from '@fortawesome/pro-duotone-svg-icons';
import { faSync } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import { useIsHandlerLoaded } from 'hooks/useIsLoading';
import * as IngredientList from 'types/Recipe/Detail/ErpNew/IngredientList';

type IProps = RecipeErpViewComponentProps & {
	ingredientMapping: IngredientList.Type;
};

const Button = (props: IProps) => {
	const { t } = useTranslation();
	const { classes } = useStyles();

	const [isLoaded, createNewErpRecipe] = useIsHandlerLoaded(() =>
		props.handlers.createNewErpRecipe(props.ingredientMapping)
	);

	const renderIcon = (): JSX.Element => {
		if (isLoaded) return <FontAwesomeIcon icon={faPlus} size="lg" />;
		return <FontAwesomeIcon icon={faSync} size="lg" spin={true} />;
	};

	return (
		<button
			type="button"
			className={['btn', 'btn-primary', classes.button].join(' ')}
			onClick={createNewErpRecipe}
		>
			{renderIcon()} {t('header:CREATE')}
		</button>
	);
};

export default Button;

export const useStyles = tss.create({
	button: {
		minWidth: '200px',
	},
});
